import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const StyledFlag = styled.img`
  width: ${({ size }) => `${size}px`};
  border-radius: 1px;
  box-shadow: 0px 2px 2px #00000029;

  ${({ height }) =>
    height &&
    css`
      height: ${height}px;
      width: initial;
    `}
`;

const Flag = ({ code, size, height, className }) => {
  if (!code) {
    return null;
  }

  return (
    <StyledFlag
      src={`${process.env.PUBLIC_URL}/flags/${code.toUpperCase()}.svg`}
      alt={`flag-${code}`}
      size={size}
      height={height}
      className={className}
    />
  );
};

Flag.defaultProps = {
  size: 16,
  className: ''
};

Flag.propTypes = {
  code: PropTypes.string,
  size: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};

export default React.memo(
  Flag,
  (prevProps, nextProps) => prevProps.code === nextProps.code
);
